<template>
  <!-- 项目车次 -->
  <div>
    <!-- 头部-->
    <div class="city-child-head">
      <!-- 标题 -->
      <div class="city-child-head-left float-l">
        <div class="city-child-head-icon"></div>
        <span>项目车次</span>
      </div>
    </div>
    <!-- 内容 -->
    <div class="city-content city-content-chunk-box">
      <div class="city-box">
        <dv-scroll-board class="dv-scr-board" :config="config" />
      </div>
    </div>
  </div>
</template>
<script>
import { getFleetStatistics } from '../../api/holdMy.js'
export default {
  data() {
    return {
      refreshImgIng: null, // 刷新定时器
      getData: {
        cityName: this.$route.query.cityName,
        city: this.$route.query.cityName,
      },
      config: {
        header: ['项目', '公司', '近7天车次', '今日车次'],
        data: [],
        rowNum: 23, //表格行数
        headerHeight: 25,
        headerBGC: 'rgba(0,144,255,0.2)', //表头
        oddRowBGC: 'rgba(26, 201, 255, 0)', //奇数行
        evenRowBGC: 'rgba(26, 201, 255, 0', //偶数行
        align: ['left', 'left', 'center', 'center'],
        columnWidth: [70, 70, 55, 55],
      },
    }
  },
  components: {},
  created() {},
  mounted() {
    this.refreshScale()
  },
  beforeDestroy() {
    clearInterval(this.refreshImgIng)
  },
  methods: {
    // 刷新数据
    refreshScale() {
      this.fleetStatistics()
      this.refreshImgIng = setInterval(() => {
        this.fleetStatistics()
      }, 1000 * 60 * 30)
    },
    // 获取车队统计
    fleetStatistics() {
      let that = this
      getFleetStatistics({ ...this.getData })
        .then((res) => {
          if (res.result == 0) {
            let data = res.userdata
            var data1 = []
            data.forEach((element) => {
              data1.push([
                `<span style="color:rgba(255, 255, 255, 0.4980392156862745);">${
                  element.company ? element.company : ''
                }</span>`,
                element.name ? element.name : '--',
                element.sevenDayTotalTransportOrderCount
                  ? element.sevenDayTotalTransportOrderCount
                  : 0,
                element.todayTotalTransportOrderCount
                  ? element.todayTotalTransportOrderCount
                  : 0,
              ])
            })
            that.config.data = data1
            that.config = { ...that.config } //关键,展开数组对象重新赋值.不写数据出不来
          }
        })
        .catch((error) => {
          console.log(error)
        })
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../../assets/scss/city.scss';

.city-content {
  height: 100%;

  .city-box {
    padding: 0px;
    overflow: hidden;
    width: 100%;
    height: calc(100% - 50px);

    .dv-scr-board {
      height: 100%;
    }

    .cj-1 {
      margin: 20px 20px;
    }

    .cj-box {
      background: inherit;
      background-color: rgba(26, 201, 255, 0.2980392156862745);
      height: 49px;
      font-size: 20px;
      line-height: 48px;
      padding-left: 10px;
      color: #1ac7fd;
    }

    .cj-box2 {
      width: 49%;
    }

    .cj-righ {
      margin-right: 10px;
    }

    .cj-2 {
      display: flex;
      align-content: center;
      width: 100%;
      margin-top: 15px;
    }
  }
}
</style>
